import React, { Component } from "react";
import moment from 'moment';
import DatePicker from 'react-datepicker';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import Select from 'react-select';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../../loginService/logout";

const backend = require('../../../config.js').backend;

class BudgetPlanMgm extends Component {

    constructor(props) {

        super(props);

        this.state = {

            table: props.table,
            planId: props.table.PlanID,
            desigId: props.table.SourceFundDesigID,
            fundStartDate: props.table.StartDate,
            fundEndDate: props.table.EndDate,
            bankAccId: props.table.SourceBankAccId,
            bankAccounts: props.bankAccounts, // obj
            bankAccountsDropDown: props.bankAccountsDropDown, // list
            // bankAccounts:[],
            desigs: {},
            desigsList: [],
            planEdit: false,
            staffid: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }

        this.enablePlanEdit = this.enablePlanEdit.bind(this);
        this.disablePlanEdit = this.disablePlanEdit.bind(this);
        this.handleChangeSourceFund = this.handleChangeSourceFund.bind(this);
        this.renderSourceBankAcc = this.renderSourceBankAcc.bind(this);
        this.handleFundStartDateChange = this.handleFundStartDateChange.bind(this);
        this.handleFundEndDateChange = this.handleFundEndDateChange.bind(this);
        this.updateBudgetPlan = this.updateBudgetPlan.bind(this);
        this.getPlanByIdAndUpdateState = this.getPlanByIdAndUpdateState.bind(this);
        this.callApiToUpdateBudgetPlan = this.callApiToUpdateBudgetPlan.bind(this);
        this.deletePlan = this.deletePlan.bind(this);

    }

    componentDidMount() {

        this.getAllDesignames()
            .then((desigs) => {
                this.setState({ desigs: desigs });
            })

    }

    getAllDesignames = _ => {

        var that = this;

        // console.log('getAllDesigNames');
        return new Promise(function (resolve, reject) {

            var url = `api/v1/gift/alldesignames`;
            fetch(backend + url, {
                method: 'GET',
                credentials: "include"
            })
                .then(response => response.json())
                .then((data) => {
                    //   console.log(data);
                    if (data.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else {
                        resolve(data);
                    }
                })
                .catch((err) => {
                    console.log('getAllDesignames error', err);
                    reject(err)
                })

        })

    }


    enablePlanEdit = () => {
        console.log('enable plan editing');
        var { planEdit } = this.state;

        if (!planEdit) {
            this.setState({ planEdit: true })
        }
    }


    disablePlanEdit = () => {
        console.log('disable plan editing');
        var { planEdit } = this.state;
        if (planEdit) {
            this.setState({ planEdit: false })
        }
    }


    handleChangeSourceFund = (desig) => {
        this.setState({ desigId: desig.value });
    }


    handleFundStartDateChange = (date) => {
        // console.log('handleFundStartDateChange');
        date = moment(date).format('YYYY-MM-DD');
        this.enablePlanEdit();
        this.setState({
            fundStartDate: date
        });
    }


    handleFundEndDateChange = (date) => {
        // console.log('handleFundEndDateChange');
        date = moment(date).format('YYYY-MM-DD');
        this.enablePlanEdit();
        this.setState({
            fundEndDate: date
        });
    }

    updatePlanList = _ => {
        console.log('refresh updatePlanList')
        this.props.refresh();
    }

    getPlanByIdAndUpdateState = () => {
        const { planId } = this.state;
        var that = this;

        var url = `api/v1/budgetplan/` + planId

        fetch(backend + url, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {
                console.log(data);
                if (data.redirect) {
                    that.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else {
                    this.setState({ table: data[0] });
                }
            })
            .catch((err) => {
                console.log('getPlanById error', err);
            })
    }


    isDateValid = _ => {

        const { fundStartDate } = this.state;
        const { fundEndDate } = this.state;
        if (fundStartDate > fundEndDate) return false;
        return true;

    }


    callApiToUpdateBudgetPlan = _ => {

        const { desigId } = this.state;
        const { fundStartDate } = this.state;
        const { fundEndDate } = this.state;
        const { planId } = this.state;
        const { staffid } = this.state;
        const { bankAccId } = this.state;
        var endDate = moment(fundEndDate).format('YYYY-MM-DD');
        var startDate = moment(fundStartDate).format('YYYY-MM-DD');
        var that = this;

        // console.log('callApiToUpdateBudgetPlan', desigId, startDate,endDate, planId, bankAccId)

        var plan = {
            'start': startDate,
            'end': endDate,
            'sourcefundid': desigId,
            'sourcebankid': bankAccId
        }

        console.log('plan', plan);

        return new Promise(function (resolve, reject) {

            var url = backend + `api/v1/budgetplan/` + staffid + `/` + planId;

            return fetch(url, {
                method: 'PUT',
                credentials: "include",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'plan': plan })
            })
                .then(response => response.json())
                .then(response => {
                    console.log(response);
                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    if (response.hasOwnProperty('message')) {
                        reject(response.message)
                    }
                    resolve(response);
                })
                .catch(function (v) {
                    console.log('error: ', v);
                    reject(v);
                });

        })

    }


    deletePlan = _ => {

        // windows warning
        const { planId } = this.state;
        const { staffid } = this.state;
        var that = this;

        var answer = window.confirm("Are you sure you want to delete this fund-raising project ?")

        if (answer) {

            fetch(backend + `api/v1/budgetplan/` + planId + '/' + staffid, {
                method: 'DELETE',
                credentials: "include"
            })
                .then(response => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.redirect) {
                        that.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (response.Error !== undefined) {
                        NotificationManager.error('Fund-raising project cannot be deleted ' + (response.Error).toString());
                    }
                    else {
                        NotificationManager.success('Fund-raising project is deleted successfully');
                        // Delete from display
                        this.updatePlanList()
                    }

                })
                .catch(err => console.error(err));

        } else {
            // Do nothing!
        }

    }

    updateBudgetPlan = _ => {

        console.log('updateBudgetPlan');

        //validate the inputs
        if (this.isDateValid()) {
            console.log('isDateValid is true');

            this.callApiToUpdateBudgetPlan()
                .then((result) => {

                    console.log(result);
                    if (result) {

                        this.getPlanByIdAndUpdateState();
                        NotificationManager.success('Updated succesfully!');
                        this.disablePlanEdit();
                    }

                })
                .catch((err) => {

                    console.log(err)
                    NotificationManager.error('Error! ' + err);

                })

        }

        else {

            NotificationManager.error('Please check start date or end date !');

        }

    }

    // Source Fund Desig Dropdown
    renderSourceFund = (desigId, planId) => {

        const { desigs } = this.state;
        const { planEdit } = this.state;
        var desigName = desigs[desigId];
        var desigsList = [];

        Object.keys(desigs).forEach(function (key) {
            desigsList.push({
                'value': key,
                'label': desigs[key]
            })
        });

        desigsList.sort((a, b) => (a.label > b.label) ? 1 : -1);

        // dropdown
        if (planEdit) {

            return (
                <div className="buttons">
                    <div className="btn-group">
                        <div className='source-label'>Source Fund: </div>
                        <Select
                            className='react-select-container'
                            width='100px'
                            options={desigsList}
                            defaultValue={{ label: desigName, value: desigId }}
                            isSearchable="true"
                            placeholder="Designations"
                            onChange={this.handleChangeSourceFund}
                        />
                    </div>
                </div>
            )

        }
        // normal display
        else {

            return (
                <div className='source-display'>
                    Source Fund: {desigName} <EditIcon onClick={() => this.enablePlanEdit()} />
                </div>)

        }

    }

    renderSourceBankAcc = (bankAccId) => {
        const { bankAccounts } = this.state;
        const { bankAccountsDropDown } = this.state;
        const { planEdit } = this.state;
        var bankAccName = bankAccounts[bankAccId];

        if (planEdit) {

            return (
                <div className="buttons">
                    <div className="btn-group">
                        <div className='source-label'> Linked Bank Account: </div>
                        <Select
                            className='react-select-container'
                            width='80px'
                            options={bankAccountsDropDown}
                            defaultValue={{ label: bankAccName, value: bankAccId }}
                            isSearchable="true"
                            placeholder="Bank Accounts"
                            onChange={this.handleChangeSourceBankAcc}
                        />
                    </div>
                </div>
            )

        }
        // normal display
        else {

            return (
                <div className='source-display'>
                    Linked Bank Account: {bankAccName} <EditIcon onClick={() => this.enablePlanEdit()} />
                </div>)

        }

    }

    handleChangeSourceBankAcc = (bankAcc) => {
        console.log(bankAcc)
        this.setState({ bankAccId: bankAcc.value });
    }

    render() {
        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        const { desigId } = this.state;
        const { bankAccId } = this.state;
        const { planId } = this.state;
        const { fundStartDate } = this.state;
        const { fundEndDate } = this.state;
        const { planEdit } = this.state;

        return (
            <div className="budget-table-details">

                <div className="row">

                    <div className='source-fund col-sm-12'>
                        <div className='source-fund col-sm-5'>
                            {this.renderSourceFund(desigId, planId)}
                        </div>

                        <div className='source-fund col-sm-5'>
                            {this.renderSourceBankAcc(bankAccId)}
                        </div>

                        <div className='float-right col-sm-2'> Delete<DeleteIcon onClick={this.deletePlan} /></div>
                    </div>

                    <div className="col-sm-5 dates">
                        Start Date:

                        {this.state.planEdit ?
                            moment(fundStartDate).format("YYYY-MM-DD") :
                            moment(this.state.table.StartDate).format("YYYY-MM-DD")}

                        <div className="startdate">
                            <DatePicker
                                selected={(this.state.fundStartDate === '') ?
                                    new Date() :
                                    new Date(this.state.fundStartDate)}
                                onChange={this.handleFundStartDateChange}
                                customInput={<EditIcon />}
                                dateFormat='dd-MM-yyyy'
                            />
                        </div>
                    </div>

                    <div className="col-sm-5 dates">
                        End Date:
                        {this.state.planEdit ? moment(fundEndDate).format("YYYY-MM-DD") : moment(this.state.table.EndDate).format("YYYY-MM-DD")}

                        <div className="startdate">
                            <DatePicker
                                selected={(this.state.fundEndDate === '') ? new Date() : new Date(this.state.fundEndDate)}
                                onChange={this.handleFundEndDateChange}
                                customInput={<EditIcon />}
                                dateFormat='dd-MM-yyyy'
                            />
                        </div>
                    </div>

                    <div className='col-sm-12'>
                        {planEdit ?
                            <div>
                                <button type="button" className="btn btn-primary submit" onClick={() => this.updateBudgetPlan()}>Save</button>
                                <button type="button" className="btn btn-primary submit" onClick={this.disablePlanEdit}>Cancel</button>
                            </div>
                            :
                            null}
                    </div>

                    <NotificationContainer />

                </div>

            </div>
        )
    }

}


export default BudgetPlanMgm;
